import { FormSuccessWrapper } from "styles/jss/Forms.styles";
import { useTranslation } from "next-i18next";
import { SuccessIcon } from "./IconsSvg";

export default function FormSuccess({ successKey, title, subtitle, children }) {
  const { t } = useTranslation(["form"]);

  return (
    <FormSuccessWrapper>
      <i>
        <SuccessIcon />
      </i>
      <p className={"title"}>{!!title ? title : t("success-p1")}</p>
      <span className={"subtitle"}>{!!subtitle ? subtitle : t("success-p2")}</span>
      <div className={"tracking_key"}>
        <span className={"key"}>{t("success-key")}</span>
        <span className={"numKey"}>{successKey}</span>
      </div>
      {children}
    </FormSuccessWrapper>
  );
}
